import React from 'react';
import styles from './cookiehead.module.css';

function CookieHead() {
	return (
		<div className={styles.cookiehead}>
			<h1>Cookie Policy for DevAsk</h1>
			<h5>
				This is the Cookie Policy for DevAsk, accessible from URL checking
			</h5>
		</div>
	);
}

export default CookieHead;
